import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from "@angular/forms";
import { FormService } from "../../../../services/form.service";
import {KeyValue} from '@angular/common';

interface Choice {
	[index: number]: string;
}
type Choices = Choice[];

@Component( {
	selector: 'app-sub-question',
	templateUrl: './sub-question.component.html',
	styleUrls: ['./sub-question.component.scss']
} )
export class SubQuestionComponent implements OnInit {

	@Input() mainQuestionIndex !: number;
	@Input() mainQuestionKey!: number;
	@Input() subQuestion !: number;
	thirdPartyForm !: UntypedFormGroup
	formGroupName : string = 'thirdPartyForm'
	public questionType !: string;
	public questionControlName !: string;
	public questionLabel !: string;
	public questionChoices : Choices | undefined;

	constructor( private formService: FormService ) {
	}

	ngOnInit(): void {

		this.thirdPartyForm = this.formService.thirdPartyForm as UntypedFormGroup;

		var mainQuestion = this.formService.questions![this.mainQuestionIndex];

		// Type 1 = input
		// Type 2 = select
		this.questionType = mainQuestion['extra_' + this.subQuestion + '_type'];

		// The dynamic name
		this.questionControlName = 'question_' + this.mainQuestionKey + '_' + this.subQuestion;
		this.questionLabel = mainQuestion['extra_' + this.subQuestion + '_question'];

		if( this.questionType === "2" ) {

			// Get choices as object. TURN IT INTO AN ARRAY
			this.questionChoices = Object.values( mainQuestion['extra_' + this.subQuestion + '_options'] );

			// REMOVE THE "CHOOSE" OPTION FROM THE LIST BECAUSE IT MESSES UP THE INDEX
			// this.questionChoices = this.questionChoices.slice(0, -1);
		}
	}
}
